import { gql } from '@apollo/client/core';
import { ProfileLogo } from '.';

const companyProfileFragment = gql`
  fragment CompanyProfile on CompanyProfile {
    ...ProfileLogo
  }
  ${ProfileLogo.fragment}
`;

export default companyProfileFragment;
